/**
 * PhiFriendlyNote — a soft, non-alarming reminder about member information.
 *
 * Two flavors:
 *   - "no-phi" (default): for workspaces that should stay free of member
 *     details (risk, issues log, PSI). Friendly nudge, nothing scary.
 *   - "minimum-necessary": for Privacy, where member information belongs by
 *     design and the reminder is to keep it to the minimum necessary.
 */
import React from 'react';

export default function PhiFriendlyNote({ variant = 'no-phi', className = '' }) {
  return (
    <div className={`flex items-start gap-2 rounded-lg border border-sky-100 bg-sky-50/70 px-3 py-2 ${className}`}>
      <span aria-hidden className="text-sky-500 text-sm leading-5">☂</span>
      <div className="text-[12px] leading-relaxed text-sky-900">
        {variant === 'minimum-necessary' ? (
          <>
            <span className="font-semibold">A gentle reminder:</span> this case file may contain member information by design.
            Please enter only the minimum necessary, keep identifiers in the case fields rather than free-text notes when you can,
            and share exports only with people who need them.
          </>
        ) : variant === 'upload' ? (
          <>
            <span className="font-semibold">Before you upload:</span> please avoid files that contain protected health
            information, things like member names, Medicare IDs, or birthdates. A summary or a de-identified copy works
            just as well. If PHI does slip through, that is perfectly fine, it happens. Just give Compliance a quick
            heads-up so it stays protected. A report is always appreciated and never gets anyone in trouble.
          </>
        ) : variant === 'ingest' ? (
          <>
            <span className="font-semibold">Friendly reminder:</span> universes with member data are welcome here, they go
            straight to the Scrubber and only the results are kept. For every other document type, please keep member
            details out. If member information slipped in somewhere, just let Privacy or Compliance know and it will be tidied up.
          </>
        ) : (
          <>
            <span className="font-semibold">Friendly reminder:</span> please keep member details out of this space.
            No names, birthdates, or member numbers, results and reference numbers say everything you need.
            If member information slipped in somewhere, just let Privacy or Compliance know and it will be tidied up.
          </>
        )}
      </div>
    </div>
  );
}
